import {
  LOCATION_CLICK,
  LOCATION_SWIPE_RIGHT,
  LOCATION_SWIPE_LEFT,
  SET_ACTIVE_LOCATION,
  TOGGLE_MAP_VIEW,
  CLOSE_ZOOM,
  TOGGLE_SETTINGS,
  GET_LOCATIONS,
  RESET_STATE
} from "../data/constants";

import api from "../../../services/api/";

export const resetState = () => {
  return {
    type: RESET_STATE
  };
};

export const settingsToggle = () => {
  return {
    type: TOGGLE_SETTINGS
  };
};

export const getLocations = () => {
  return {
    type: GET_LOCATIONS,
    promise: api.get("/sdcdetails")
  };
};

export const closeZoom = () => {
  return {
    type: CLOSE_ZOOM
  };
};

export const handleLocationClick = place => {
  return { type: LOCATION_CLICK, payload: place };
};

export const handleLocationSwipe = direction => (dispatch, getState) => {
  const {
    cardNo,
    serviceCenterLocations,
    activeLocation
  } = getState().serviceCenters;

  const placeIndex = serviceCenterLocations.indexOf(activeLocation);

  if (direction === "Left" && cardNo !== serviceCenterLocations.length - 2) {
    dispatch(_swipeLocationLeft());
    dispatch(setActiveLocation(serviceCenterLocations[placeIndex + 1]));
  } else if (direction === "Right" && cardNo !== -1) {
    dispatch(_swipeLocationRight());
    dispatch(setActiveLocation(serviceCenterLocations[placeIndex - 1]));
  }
};

export const setActiveLocation = place => {
  return { type: SET_ACTIVE_LOCATION, payload: place };
};

const _swipeLocationLeft = () => {
  return { type: LOCATION_SWIPE_LEFT };
};

const _swipeLocationRight = () => {
  return { type: LOCATION_SWIPE_RIGHT };
};

export const changeMapView = view => {
  return { type: TOGGLE_MAP_VIEW, payload: view };
};
